import { FC } from "react";
import { Text, Box, BoxProps } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import Logo from "./Logo";

const fade = keyframes`
  0% {
    opacity: .1
  }
  50% {
    opacity: 1
  }
  100% {
    opacity: .1
  }
`;

const LoadingLogo: FC<BoxProps> = (props) => {
  return (
    <Box
      width="100%"
      height="calc(100vh - var(--header-height))"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...props}
    >
      <Logo sx={{ animation: `${fade} infinite 1.5s` }} fontSize="3xl" />
    </Box>
  );
};

export default LoadingLogo;
